import { render, staticRenderFns } from "./TransactionLog.vue?vue&type=template&id=5b2f888e&scoped=true&"
import script from "./TransactionLog.vue?vue&type=script&lang=js&"
export * from "./TransactionLog.vue?vue&type=script&lang=js&"
import style0 from "./TransactionLog.vue?vue&type=style&index=0&id=5b2f888e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b2f888e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5b2f888e')) {
      api.createRecord('5b2f888e', component.options)
    } else {
      api.reload('5b2f888e', component.options)
    }
    module.hot.accept("./TransactionLog.vue?vue&type=template&id=5b2f888e&scoped=true&", function () {
      api.rerender('5b2f888e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/game/TransactionLog.vue"
export default component.exports